import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import APIs from "../../APIs";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const Myaddress = () => {
  const navigate = useNavigate();
  const [addresses, setAddresses] = useState([]);
  const [user, setUser] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const userDataStr =
    typeof window !== "undefined" ? sessionStorage.getItem("userData") : null;
  const userData = userDataStr ? JSON.parse(userDataStr) : null;
  const user_id = userData?.user_id;

  // fetch user details
  useEffect(() => {
    if (!user_id) return;
    (async () => {
      try {
        const res = await APIs.post(
          "user/getUserById",
          { user_id },
          { headers: { "Content-Type": "application/json" } }
        );
        setUser(res.data?.data || null);
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    })();
  }, [user_id]);

  // fetch all addresses
  const fetchAddresses = async () => {
    if (!user_id) return;
    try {
      const res = await APIs.post("address/getAddressByUser", { user_id });
      if (res.data?.status) {
        const addrs = res.data.data || [];
        setAddresses(addrs);

        // set selectedAddress to default one
        const defaultAddr = addrs.find(
          (a) =>
            a.is_default === true ||
            a.is_default === "1" ||
            a.is_default === 1 ||
            a.is_default === "true"
        );
        if (defaultAddr) setSelectedAddress(String(defaultAddr.address_id));
      } else {
        setAddresses([]);
      }
    } catch (err) {
      console.error("Failed to fetch addresses:", err);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, [user_id]);

  const formatFullAddress = (addr) =>
    [addr.address, addr.landmark, addr.city, addr.state, addr.country, addr.pincode]
      .filter(Boolean)
      .join(", ");

  // set as default address
  const onSelectAddress = async (addr) => {
    const confirm = await Swal.fire({
      text: "Do you want to set this address as your default address?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    const prevSelected = selectedAddress;
    setSelectedAddress(String(addr.address_id));

    try {
      const res = await APIs.post("address/udapteDefaultAddress", {
        user_id,
        address_id: addr.address_id,
      });

      if (res.data?.status === true || res.data?.status === "success") {
        toast.success(res.data?.message || "Default address updated successfully!");
        await fetchAddresses();
      } else {
        setSelectedAddress(prevSelected);
        toast.error(res.data?.message || "Failed to set default address");
      }
    } catch (err) {
      setSelectedAddress(prevSelected);
      toast.error("Something went wrong while setting default address");
    }
  };

  // delete address
  const handleDeleteAddress = async (address_id) => {
    const confirm = await Swal.fire({
      text: "Do you want to delete this address?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await APIs.post("address/deleteAddress", { address_id });
      if (res.data?.status === true || res.data?.status === "success") {
        toast.success(res.data?.message || "Address deleted successfully");
        if (String(selectedAddress) === String(address_id)) setSelectedAddress(null);
        await fetchAddresses();
      } else {
        toast.error(res.data?.message || "Failed to delete address");
      }
    } catch (err) {
      toast.error("Something went wrong while deleting the address");
    }
  };

  return (
    <div className="page-content">
      <section className="step-section-md">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <Sidebar />
            </div>

            <div className="col-lg-9">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="card-title">My Address</h5>
                <Link to="/newaddress" className="btn btn-success">
                  Add Address
                </Link>
              </div>

              <div className="row g-sm-4 g-3">
                {addresses.length > 0 ? (
                  addresses.map((addr) => {
                    const isDefault =
                      addr.is_default === true ||
                      addr.is_default === "1" ||
                      addr.is_default === 1 ||
                      addr.is_default === "true";

                    return (
                      <div
                        key={addr.address_id}
                        className="col-xxl-4 col-xl-6 col-lg-6 col-md-6"
                      >
                        <div
                          className={`address-box position-relative ${
                            isDefault ? "border-success" : ""
                          }`}
                        >
                          {/* Default Badge */}
                          {isDefault && (
                            <span
                              className="badge bg-success position-absolute top-0 end-0 m-2"
                              style={{ fontSize: "12px" }}
                            >
                              Default
                            </span>
                          )}

                          <div>
                            {/* Radio */}
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="selectedAddress"
                                id={`address_${addr.address_id}`}
                                value={String(addr.address_id)}
                                checked={addr.is_default == "Yes"}
                                onChange={() => onSelectAddress(addr)}
                              />
                            </div>

                           
                            {/* Address Type Label with color */}
                           <div
                                className={`label ${
                                    addr.address_type?.toLowerCase() === "home"
                                    ? "bg-success"
                                    : addr.address_type?.toLowerCase() === "office"
                                    ? "bg-warning text-dark"
                                    : "bg-danger"
                                }`}
                                >
                                {addr.address_type}
                            </div>


                            {/* Table */}
                            <div className="table-responsive address-table">
                              <table className="table">
                                <tbody>
                                  <tr>
                                    <td>{user?.full_name || "User"}</td>
                                  </tr>
                                  <tr>
                                    <td>{formatFullAddress(addr)}</td>
                                  </tr>
                                  <tr>
                                    <td>{user?.mobile_number || "No Phone"}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          {/* Buttons */}
                          <div className="button-group mt-2">
                            <button
                              className="btn btn-sm add-button w-100 mb-2"
                              onClick={() =>
                                navigate("/newaddress", { state: { address: addr } })
                              }
                            >
                              <i className="ti-pencil me-2"></i> Edit
                            </button>
                            <button
                              className="btn btn-sm add-button w-100"
                              onClick={() => handleDeleteAddress(addr.address_id)}
                            >
                              <i className="ti-trash me-2"></i> Remove
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="col-12 text-center my-5">
                    <img
                      src="/images/nodatafoundimg.png"
                      alt="No addresses found"
                      className="img-fluid mb-3"
                      style={{ maxWidth: "200px" }}
                    />
                    <p>No addresses found.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Myaddress;
